import { createSelector } from 'reselect';
import { TimerStatus } from 'shovel-lib/types';
import { RootState } from '@state/types';
import { savedTimerMode } from '@utils/timer';

export const getActiveTimer = createSelector([(state: RootState) => state.timer], timer => {
  const { plannedTaskId, masterTaskId, status, timePassedInSeconds, startedInUtc, title } = timer;
  return !plannedTaskId || status === TimerStatus.INITIAL
    ? undefined
    : {
        status,
        plannedTaskId,
        masterTaskId,
        title,
        timePassedInSeconds,
        startedInUtc,
        plannedMinutes: timer.plannedMinutes,
        sessionUsedMinutes: timer.sessionUsedMinutes,
        sessionIsUsed: timer.sessionIsUsed,
        reading: timer.reading
      };
});

export const getPulsingTaskId = ({ timer }) => (timer.status === TimerStatus.PAUSED ? timer.plannedTaskId : undefined);
export const getTimerTaskId = ({ timer }) => (timer.status !== TimerStatus.INITIAL ? timer.plannedTaskId : undefined);

export const getActiveTimerInfo = createSelector(
  [(state: RootState) => state.timer.status, (state: RootState) => state.timer.plannedTaskId],
  (status, plannedTaskId) => ({
    status,
    plannedTaskId
  })
);

/** What the timer's number shows: the student's last choice, Stopwatch until they choose (utils/timer.ts). */
export const getTimerMode = (state: RootState) => savedTimerMode(state.settings.userSettings);
